import {ID, Response} from '../../../../../../_metronic/helpers'
export type Template = {
 
  id?: string
  name?: string
  printableTemplateId?: string
  avatar?: any
  original?: any
  raw?: any
  video?: any
  type?: 'classic' | 'magic' | 'sticker' | 'ai'
  thumbnailMark?: string
  dateCreated?: string
  updatedOn?: string
  disable?: boolean,
  dooh?: boolean
  uploadAllowed?: boolean
  microsite?: boolean
  print?: boolean
  dimensions?: {width?: "", height?:""} //{height: 1080, width: 720 }
  template?: any
  tags?: Array<string>
  faces?: string[];  // URLs after upload (string type)
  facesFiles?: File[];  // URLs after upload (string type)
  info?: string

}

export type TemplatesQueryResponse = Response<Array<Template>>

export const initialTemplate: Template = {
  avatar: '',
  name: '',
  printableTemplateId: '',
  info: '',
  type: 'classic',
  dooh: false,
  microsite: false,
  disable: false,
  print: false,
  uploadAllowed: false,
}
